const asyncDebounce = (fn, delay) => {
  let inDebounce = null

  return (...args) =>
    new Promise((resolve, reject) => {
      clearTimeout(inDebounce)
      inDebounce = setTimeout(async () => {
        const response = await fn(...args).catch((err) => reject(err))
        resolve(response)
      }, delay)
    })
}

export default asyncDebounce
